import * as React from "react";
import Timestamp from "components/common/Timestamp";
import Status from "search/events/Status";
import useLicenseCheck from "license/useLicenseCheck";
import OwnerCell from "security-app/components/SecurityEvents/Alerts/OwnerCell";
const useCondition = () => {
  const { security } = useLicenseCheck();
  return security == null ? void 0 : security.isValid;
};
const eventsAttributes = [
  {
    attribute: "opened_at",
    displayValue: (value) => /* @__PURE__ */ React.createElement(Timestamp, { dateTime: value }),
    sortable: true,
    title: "Opened At",
    useCondition
  },
  {
    attribute: "updated_at",
    displayValue: (value) => /* @__PURE__ */ React.createElement(Timestamp, { dateTime: value }),
    sortable: true,
    title: "Updated At",
    useCondition
  },
  {
    attribute: "closed_at",
    displayValue: (value) => /* @__PURE__ */ React.createElement(Timestamp, { dateTime: value }),
    sortable: true,
    title: "Closed At",
    useCondition
  },
  {
    attribute: "owner",
    displayValue: (value) => value ? /* @__PURE__ */ React.createElement(OwnerCell, { owner: value }) : "",
    sortable: true,
    title: "Owner",
    useCondition
  },
  {
    attribute: "status",
    displayValue: (value) => /* @__PURE__ */ React.createElement(Status, { statusId: value }),
    sortable: true,
    title: "Status",
    useCondition
  },
  {
    attribute: "risk_score",
    title: "Risk Score",
    sortable: true,
    useCondition
  }
];
export default eventsAttributes;
